"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderersUIType = exports.RenderersType = exports.templatesMap = exports.TEMPLATES = void 0;
var TEMPLATES;
(function (TEMPLATES) {
    TEMPLATES["SOC"] = "SOC";
    TEMPLATES["TRANSFER_OASIS"] = "TRANSFER_OASIS";
    TEMPLATES["ROC"] = "ROC";
    TEMPLATES["REVISIT"] = "REVISIT";
    TEMPLATES["DC_SUMMARY"] = "DC_SUMMARY";
    TEMPLATES["DC_OASIS"] = "DC_OASIS";
    TEMPLATES["AIDE_FIRST_VISIT"] = "AIDE_FIRST_VISIT";
    TEMPLATES["AIDE_LAST_VISIT"] = "AIDE_LAST_VISIT";
    TEMPLATES["RECERT"] = "RECERT";
    TEMPLATES["EVAL"] = "EVAL";
    TEMPLATES["ADD_DELETE_DISCIPLINE"] = "ADD_DELETE_DISCIPLINE";
    TEMPLATES["HANDS_OFF"] = "HANDS_OFF";
    TEMPLATES["VITAL"] = "VITAL";
    TEMPLATES["SCHEDULE_SOC"] = "SCHEDULE_SOC";
    TEMPLATES["SCHEDULE_EVAL"] = "SCHEDULE_EVAL";
    TEMPLATES["MISSED_VISIT"] = "MISSED_VISIT";
    TEMPLATES["SCHEDULE_FIRST_VISIT"] = "SCHEDULE_FIRST_VISIT";
    TEMPLATES["UPDATE_SERVICE_TEMPLATE"] = "UPDATE_SERVICE_TEMPLATE";
    TEMPLATES["TELE_MEDICINE"] = "TELE_MEDICINE";
    TEMPLATES["SCHEDULE_ROC"] = "SCHEDULE_ROC";
    TEMPLATES["SCHEDULE_CANCEL_VISIT"] = "SCHEDULE_CANCEL_VISIT";
})(TEMPLATES || (exports.TEMPLATES = TEMPLATES = {}));
// Create an object with key as numbers and value as TEMPLATES enum values
exports.templatesMap = {
    1: TEMPLATES.SOC,
    2: TEMPLATES.TRANSFER_OASIS,
    3: TEMPLATES.ROC,
    4: TEMPLATES.REVISIT,
    5: TEMPLATES.DC_SUMMARY,
    6: TEMPLATES.DC_OASIS,
    7: TEMPLATES.AIDE_FIRST_VISIT,
    8: TEMPLATES.AIDE_LAST_VISIT,
    9: TEMPLATES.RECERT,
    10: TEMPLATES.EVAL,
    11: TEMPLATES.ADD_DELETE_DISCIPLINE,
    12: TEMPLATES.HANDS_OFF,
    13: TEMPLATES.VITAL,
    14: TEMPLATES.SCHEDULE_SOC,
    15: TEMPLATES.SCHEDULE_EVAL,
    16: TEMPLATES.MISSED_VISIT,
    17: TEMPLATES.SCHEDULE_FIRST_VISIT,
    18: TEMPLATES.UPDATE_SERVICE_TEMPLATE,
    19: TEMPLATES.TELE_MEDICINE,
    20: TEMPLATES.SCHEDULE_ROC,
    21: TEMPLATES.SCHEDULE_CANCEL_VISIT,
};
exports.RenderersType = {
    StaticArrayLayout: "StaticArrayLayout",
};
exports.RenderersUIType = {
    DataLabel: "DataLabel",
    DatePicker: "DatePicker",
    TimePicker: "TimePicker",
    AppointmentPicker: "AppointmentPicker",
    InputWithAdornment: "InputWithAdornment",
    VisitPicker: "VisitPicker",
    NPIInput: "NPIInput",
    PanelOrTestInput: "PanelOrTestInput",
};
